import React from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import Badge from '@components/ringil3/Badges/Badge';
import { isNotNullOrUndefined } from '@utils/utils';

interface ComponentProps {
  crn: string;
}

const CrnBadge: React.FC<ComponentProps> = ({ crn }) => {
  const { tr } = useTranslationLgs();
  return (
    <>
      {isNotNullOrUndefined(crn) && (
        <Badge filled={false} value={crn} highlightedValue={false} label={tr(`CrnBadge.label`, `CRN`)}></Badge>
      )}
    </>
  );
};

export default CrnBadge;
